import { Button, Input } from '@core/ui';
import { updateNickname, useAppDispatch } from '@online-webinar/store';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const UpdateNickname = () => {
    const { t } = useTranslation();
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [nickname, setNickname] = useState('');
    const dispatch = useAppDispatch();

    const update = () => {
        let n = nickname;
        n = n.trim();
        setNickname(n);
        if (n.length === 0) {
            setError(t('Validation.Nickname.Required'));
            return;
        }
        if (n.length < 3) {
            setError(t('Validation.Nickname.MinLength'));
            return;
        }
        if (n.length > 70) {
            setError(t('Validation.Nickname.MaxLength'));
            return;
        }

        setError('');
        setIsLoading(true);
        dispatch(updateNickname(n));
    };

    return (
        <div className="relative bg-accent-lighter flex flex-col px-6 py-4">
            <p className="mb-2">{t('Player.Chat.Nickname.Required')}</p>
            <Input
                readOnly={isLoading}
                className="w-full bg-transparent"
                classNames="mb-6"
                errorMessage={error}
                placeholder={t('Player.Chat.Nickname.Placeholder')}
                onChange={(e) => setNickname(e.target.value)}
                value={nickname}
            />
            <Button variant="primary" onClick={update} isLoading={isLoading}>
                {t('Player.Chat.Nickname.UpdateButton')}
            </Button>
        </div>
    );
};
